import { render, staticRenderFns } from "./consumerpolicy.vue?vue&type=template&id=7398b884&scoped=true"
import script from "./consumerpolicy.vue?vue&type=script&lang=js"
export * from "./consumerpolicy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7398b884",
  null
  
)

export default component.exports